<template>
  <div class="demo-block">
    <div class="demo-block-source">
      <slot name="source" />
      <div class="icon-btn-wrapper">
        <el-tooltip effect="dark" content="在线运行此示例" placement="top">
          <i class="el-icon-edit-outline" @click.stop="goCodepen" />
        </el-tooltip>
        <el-tooltip :content="showCode ? '收起代码' : '显示代码'" placement="top">
          <span @click="showCode = !showCode">
            <img
              v-if="!showCode"
              alt="expand code"
              src="https://gw.alipayobjects.com/zos/rmsportal/wSAkBuJFbdxsosKKpqyq.svg"
              class="code-expand-icon-show"
            >
            <img
              v-else
              alt="expand code"
              src="https://gw.alipayobjects.com/zos/rmsportal/OpROPHYqWmrMDBFMZtKF.svg"
              class="code-expand-icon-show"
            >
          </span>
        </el-tooltip>
      </div>
    </div>

    <el-collapse-transition>
      <div v-show="showCode" class="demo-block-code">
        <div v-if="$slots.default" class="demo-block-meta">
          <slot />
        </div>
        <div class="highlight">
          <slot name="highlight" />
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script type="text/babel">
import { stripScript, stripStyle, stripTemplate } from '../utils'
const packageJson = require('../../package.json')
const version = packageJson.version

export default {
  data() {
    return {
      showCode: false,
      codepen: {
        script: '',
        html: '',
        style: ''
      }
    }
  },
  created() {
    const highlight = this.$slots.highlight
    if (highlight && highlight[0]) {
      let code = ''
      let cur = highlight[0]
      if (cur.tag === 'pre' && (cur.children && cur.children[0])) {
        cur = cur.children[0]
        if (cur.tag === 'code') {
          code = cur.children[0].text
        }
      }
      if (code) {
        this.codepen.html = stripTemplate(code)
        this.codepen.script = stripScript(code)
        this.codepen.style = stripStyle(code)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const highlight = this.$el.getElementsByClassName('highlight')[0]
      if (this.$el.getElementsByClassName('description').length === 0) {
        highlight.style.width = '100%'
        highlight.borderRight = 'none'
      }
    })
  },
  methods: {
    goCodepen() {
      // since 2.6.2 use code rather than jsfiddle https://blog.codepen.io/documentation/api/prefill/
      const { script, html, style } = this.codepen
      const resourcesTpl = '<scr' + 'ipt src="//unpkg.com/vue@2.6.11/dist/vue.js"></scr' + 'ipt>' +
        '\n<scr' + `ipt src="//unpkg.com/element-ui@2.13.0/lib/index.js"></scr` + 'ipt>' +
        '\n<scr' + `ipt src="//unpkg.com/apex-ui-wh@${version}/lib/index/index.js"></scr` + 'ipt>'
      let jsTpl = (script || '').replace(/export default/, 'var Main =').trim()
      const htmlTpl = `${resourcesTpl}\n<div id="app">\n${html.trim()}\n</div>`
      const resourcesCssTpl = `@import url("//unpkg.com/element-ui@2.13.0/lib/theme-chalk/index.css");\n` +
        `@import url("//unpkg.com/apex-ui-wh@${version}/lib/style/index.css");`
      const cssTpl = `${resourcesCssTpl}\n${(style || '').trim()}\n`
      jsTpl = jsTpl
        ? jsTpl + '\nvar Ctor = Vue.extend(Main)\nnew Ctor().$mount(\'#app\')'
        : 'new Vue().$mount(\'#app\')'
      const data = {
        js: jsTpl,
        css: cssTpl,
        html: htmlTpl
      }
      const form = document.getElementById('fiddle-form') || document.createElement('form')
      while (form.firstChild) {
        form.removeChild(form.firstChild)
      }
      form.method = 'POST'
      form.action = 'https://codepen.io/pen/define/'
      form.target = '_blank'
      form.style.display = 'none'

      const input = document.createElement('input')
      input.setAttribute('name', 'data')
      input.setAttribute('type', 'hidden')
      input.setAttribute('value', JSON.stringify(data))

      form.appendChild(input)
      document.body.appendChild(form)

      form.submit()
    }
  }
}
</script>

<style lang="scss">
.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  display: inline-block;
  width: 100%;
  position: relative;
  margin: 0 0 16px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
      0 2px 4px 0 rgba(232, 237, 250, 0.5);
  }
}
.demo-block p {
  padding: 0;
  margin: 0;
}
.demo-block .icon-btn-wrapper {
  position: absolute;
  right: 16px;
  bottom: 2px;
  cursor: pointer;
  display: flex;
}
.demo-block .icon-btn-wrapper img {
  width: 18px;
  // height: 18px;
  margin-left: 20px;
  vertical-align: text-top;
}
.demo-block .demo-block-source {
  border-bottom: 1px solid #ebebeb;
  padding: 20px 24px 30px;
  color: #444;
  position: relative;
  margin-bottom: -1px;
}
.demo-block .demo-block-code {
  background-color: #f7f7f7;
  font-size: 0;
  overflow: hidden;
  pre {
    margin: 0;
    code {
      font-size: 12px;
      padding: 16px 32px;
      line-height: 1.6;
      font-family: Menlo,Monaco,Consolas,Courier,monospace;
    }
  }
}
.demo-block .demo-block-code .demo-block-meta {
  padding: 20px;
  margin: 10px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  font-size: 14px;
  line-height: 22px;
  color: #666;
  word-break: break-word;
  background-color: #fff;
}
.demo-block .demo-block-code .demo-block-meta p {
  margin: 0;
  line-height: 26px;
  background-color: #fff;
}
.demo-block .demo-block-code .demo-block-meta code {
  color: #5e6d82;
  background-color: #e6effb;
  margin: 0 4px;
  display: inline-block;
  padding: 1px 5px;
  font-size: 12px;
  border-radius: 3px;
  height: 18px;
  line-height: 18px;
  vertical-align: text-bottom;
}
.sh-checkbox {
  color: #444;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  user-select: none;
}
</style>

